import { render, staticRenderFns } from "./RequestCode.vue?vue&type=template&id=340c85a2&"
import script from "./RequestCode.vue?vue&type=script&lang=js&"
export * from "./RequestCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports